module.exports = __webpack_public_path__ + "static/media/ser_sto_dra.09844cda.png";